// @flow
import React, { useState, useEffect } from "react";
import { Typography } from "src/latest/src/components";
import Button from "../../components/base/Button/Button";
import laptop from "../../assets/icons/icon-laptop-phone.svg";
import "./Intakegreetings.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    saveResponses,
} from "../../redux/actions/questionnaireActions";
import { prepareResponseData } from "../../utils/helpers";
import { setUserToBeOnboarded } from "src/redux/actions/onboardingActions";


export default function IntakeWelcomeScreen(): React$Element<any> {
    const userRole = useSelector(
        (state) => state.authentication.loggedInUser.userRole
    );
    const clientType = useSelector(
        (state) => state.authentication.loggedInUser.metadata
    );
    const dispatch = useDispatch();
    const currentQuestions = useSelector(
        (state) => state?.questionnaireData?.currentConfig?.currentQuestions
    );
    const sessionId = useSelector(
        (state) =>
            state?.questionnaireData?.currentConfig?.questionnaireSessionId
    );
    const categoryId = useSelector(
        (state) => state?.questionnaireData?.currentConfig?.currentCategory?.id
    );
    const currentPage = useSelector(
        (state) => state?.questionnaireData?.currentConfig?.currentPage
    );
    const [clickedOnce, setClickedOnce] = useState(false);
    const [clientTypeObj, setClientTypeObj] = useState({});
    const currentPageUniqueKey = currentPage?.unique_key;
    const tenantLogo = useSelector(
        (state) => state?.configuration?.tenantLogo
    );
    const fetchingAppConfig = useSelector(
        (state) => state?.configuration?.fetchingAppConfig
    );
    const tenantContact = useSelector(
        (state) => state?.configuration?.tenantContact
    );

    const tenantName = useSelector(
        (state) => state?.configuration?.tenantName
    );

    const handleOnclick = async () => {

        setClickedOnce(true);
        const response = prepareResponseData(currentQuestions);
        const hasChangedResponses: boolean = true;

        dispatch(
            saveResponses({
                sessionId,
                categoryId,
                pageId: currentPage?.id,
                responses: response,
                hasChangedResponses,
            })
        );

        dispatch(setUserToBeOnboarded(null));
    };

    useEffect(() => {
        setClientTypeObj(clientType);
    }, [clientType, clientType]);

    return (
        <div className="welcome-greetings">
            <div className="welcome-greetings__logo">
                <Typography
                    color="color-2"
                    weight="light"
                    variant="size-34"
                    className="d-inline-block me-2"
                >
                    Welcome to
                </Typography>
                {!fetchingAppConfig && (
                    <img style={{width: "auto", height : "100px"}} src={`${decodeURIComponent(tenantLogo)}`} alt="Tenant logo" />
                )}
            </div>

            <div
                className={
                    ` mb-5 ${currentPageUniqueKey ==="therapistOnboardingBySchedulerCompletionWelcomeScreenV1" || currentPageUniqueKey === "clientOnboardingBySchedulerWelcomePage" || currentPageUniqueKey === "intakeCompletionWelcomeScreen" || currentPageUniqueKey === "clientOnboardingWelcomePage"
                        ? "welcome-greetings__therapist" 
                        : "welcome-greetings__contents"}`
                }
            >
                <div className="welcome-greetings__contents-wrapper">
                    <Typography
                        color="color-2"
                        weight="light"
                        variant="size-26"
                        className="text-center "
                    >
                        {userRole === "client" &&
                            clientTypeObj?.["client-type"] ===
                            "EXISTING_CLIENT_INTAKE"
                            ? "Thank you for updating your profile."
                            : currentPageUniqueKey ===
                                "therapistOnboardingBySchedulerCompletionWelcomeScreenV1" || currentPageUniqueKey === "clientOnboardingBySchedulerWelcomePage"
                                ? "You're almost done creating this profile."
                                : "Thank you for creating your profile."}
                    </Typography>
                    {/* <Typography
                        color='color-2'
                        weight='regular' variant='size-18' className='greetings__contents-wrapper__text-first'>
                                We'll start by asking you a bunch of questions. This is important for creating your profile, so take your time and answer honestly. The more you help us get to know you, the better insights we can provide to assist in the matching process.

                    </Typography> */}
                    {userRole === "client" &&
                        clientTypeObj?.["client-type"] ===
                        "NEW_CLIENT_INTAKE" &&
                        currentPageUniqueKey !==
                        "intakeCompletionNewClientWelcomeScreenV1" && (
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="text-center welcome-greetings__contents-wrapper__text"
                            >
                                After submitting your profile, {tenantName} will be able to help match you
                                with a therapist. Once you've been matched with
                                a therapist, we will send you an email
                                notification. If you have any questions or
                                concerns, please don't hesitate to call us at
                                {" "}{tenantContact}.
                            </Typography>
                        )}
                    {userRole === "client" &&
                        clientTypeObj?.["client-type"] ===
                        "EXISTING_CLIENT_INTAKE" &&
                        currentPageUniqueKey !==
                        "intakeCompletionNewClientWelcomeScreenV1" && (
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="text-center welcome-greetings__contents-wrapper__text"
                            >
                                Click the submit button below to update your
                                profile and access your dashboard. From there
                                you can find information about how to meet with
                                your therapist by clicking the <b><i>Meeting Info {" "}</i></b>
                                button underneath their icon.
                            </Typography>
                        )}
                    {
                        userRole === "client" && currentPageUniqueKey === "intakeCompletionSelfMatchingClientWelcomeScreenV1" && (
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="text-center welcome-greetings__contents-wrapper__text"
                            >
                                Click the submit button below to update your
                                profile and access your dashboard. From there
                                you can find information about how to meet with
                                your therapist by clicking the <b><i>Meeting Info {" "}</i></b>
                                button underneath their icon.
                            </Typography>

                        )
                    }
                    {userRole === "client" &&
                        currentPageUniqueKey ===
                        "intakeCompletionNewClientWelcomeScreenV1" && (
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="text-center welcome-greetings__contents-wrapper__text"
                            >
                                Once you submit your profile you’ll be able to
                                access your client dashboard. When you are ready
                                to meet with your therapist at a pre-scheduled
                                time, click the start session button under your
                                therapist’s icon and you will enter their
                                waiting room.
                            </Typography>
                        )}
                    {currentPageUniqueKey ===
                        "therapistOnboardingBySchedulerCompletionWelcomeScreenV1" ? (
                        <Typography
                            color="color-2"
                            weight="regular"
                            variant="size-18"
                            className="text-center welcome-greetings__contents-wrapper__text"
                        >
                            Once you submit this profile, this therapist will be
                            visible on the clinician availability page and in
                            the match results. When they are ready to complete
                            their profile and start using i2i for teletherapy,
                            they will need to be invited to finish the account
                            creation process. You can invite this therapist from
                            their onboarding tab.
                        </Typography>
                    ) : currentPageUniqueKey === "intakeCompletionWelcomeScreen" ? (
                        <Typography
                            color="color-2"
                            weight="regular"
                            variant="size-18"
                            className="text-center welcome-greetings__contents-wrapper__text"
                        >
                            Once you submit your profile you'll be able to
                            access your therapist dashboard. From there you'll
                            be able to invite your existing clients to use the
                            platform. When your client is ready to meet with you
                            they will join your Zoom personal meeting room.
                        </Typography>
                    ) : ""}

                     {currentPageUniqueKey === "clientOnboardingBySchedulerWelcomePage" ?(
                        <Typography
                            color="color-2"
                            weight="regular"
                            variant="size-18"
                            className="text-center client_OnboardingBySchedulerWelcomePage"
                        >
                          This patient’s profile will be created in i2iConnect.  If the patient did not provide all required information and any TODOs are created, those will need to be cleared on the patient’s Onboarding Tab before a selected intake appointment is booked.  If no TODOs are generated, a selected intake appointment will be immediately booked, and the provider will be notified by email.  You can give this patient access to their i2iConnect account by inviting them from their Onboarding tab.
                        </Typography>
                    ) : ""} 

                    {(currentPageUniqueKey ===
                        "PracticeAdminIntakeCompletionWelcomeScreenV1" ||
                        currentPageUniqueKey ===
                        "schedulerIntakeCompletionWelcomeScreenV1") && (
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="text-center welcome-greetings__contents-wrapper__text"
                            >
                                Once you submit your profile you'll be able to
                                access your dashboard. From there you'll be able to
                                invite clients and/or staff to use the platform, and
                                monitor their onboarding process.
                            </Typography>
                        )}
                    {currentPageUniqueKey ===
                        "therapistOnboardingBySchedulerCompletionWelcomeScreenV1" || currentPageUniqueKey === "clientOnboardingBySchedulerWelcomePage" ? (
                        ""
                    ) : (
                        <>
                            <span className="welcome-greetings__contents-wrapper__separator" />
                            <img src={laptop} alt="teletherapy" />
                            <Typography
                                color="color-2"
                                weight="regular"
                                variant="size-18"
                                className="welcome-greetings__contents-wrapper__text text-center mt-4"
                            >
                                To ensure you have the best experience please
                                use a laptop or desktop computer instead of a
                                mobile device.
                            </Typography>
                        </>
                    )}
                </div>
                <Button
                    label={clickedOnce ? "Submitting..." : "Submit"}
                    isProcessing={clickedOnce}
                    onClick={handleOnclick}
                    disabled={clickedOnce}
                />
            </div>
            <div className="mt-5 d-flex justify-content-center">
            {currentPageUniqueKey ===
                "therapistOnboardingBySchedulerCompletionWelcomeScreenV1" ? (
                ""
            ) : (
                <div className="welcome-greetings__footer">
                    <Typography
                        color="color-28"
                        weight="regular"
                        variant="size-14"
                        className="text-center welcome-greetings__footer-text"
                    >
                        i2iConnect is a technology platform that provides
                        clinicians and their clients with tools to facilitate
                        the provision of care. i2iConnect does not provide
                        clinical advice, diagnosis or treatment services.
                    </Typography>
                    <Typography
                        color="color-28"
                        weight="regular"
                        variant="size-14"
                        className="text-center"
                    >
                        i2i LLC does not recommend or endorse specific service
                        providers. We provide data and insights to users that
                        may assist the user in making their own decisions. These
                        insights are based on the experience of prior users and
                        do not necessarily apply to you. i2i LLC does not make
                        any guarantees regarding the insights generated by the
                        platform or the services provided by users of the
                        platform.
                    </Typography>
                </div>
            )}
            </div>
        </div>
    );
}
